import React from "react";
import { VisuallyHidden } from "react-aria";
import {
    DateFieldProps,
    DateInput,
    DateSegment,
    DateValue,
    FieldError,
    Label,
    DateField as ReactAriaDateField,
    Text,
} from "react-aria-components";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { InputProps } from "./Input";

import styles from "./index.module.scss";

interface Props<T extends DateValue> extends InputProps, DateFieldProps<T> {}

export const DateField = <T extends DateValue>({
    label,
    labelVisible = true,
    description,
    ...props
}: Props<T>) => {
    return (
        <ReactAriaDateField {...props}>
            <Label
                className={concatClassNames([
                    styles.label,
                    props.isRequired ? styles.required : undefined,
                ])}
            >
                {labelVisible ? (
                    label
                ) : (
                    <VisuallyHidden>{label}</VisuallyHidden>
                )}
            </Label>
            <DateInput className={styles.dateInput}>
                {(segment) => <DateSegment segment={segment} />}
            </DateInput>
            {description && <Text slot="description">{description}</Text>}
            <FieldError className={styles.errorMessage}>
                {({ validationErrors }) => validationErrors.join(", ")}
            </FieldError>
        </ReactAriaDateField>
    );
};
